<template>
    <div class="choose-doctors">
        <el-dialog title="选择菜品" :model-value="modelValue" @update:model-value="updateVisible" class="roll-dialog">
            <!-- 搜索框 -->
            <el-form :model="searchForm" style="margin-bottom: 10px;display: flex;    width: 20vw;">
                <el-input v-model="searchForm.keyword" placeholder="请输入关键词搜索" @keyup.enter="siftsea" style="width: 10vw;"></el-input>
                <el-button type="primary" @click="siftsea">搜索</el-button>
            </el-form>
            <el-table v-loading="loading" height="60vh" element-loading-text="加载中，请稍后..." :data="doctorfiles" key="slot"
                style="text-align: center">
                <el-table-column label="" width="40vw">
                    <template #default="scope">
                        <el-radio class="radio" v-model="selectedDoctor"
                            :label="scope.row.id">&nbsp;</el-radio>
                    </template>
                </el-table-column>
                <el-table-column label="序号" width="30">
                    <template v-slot="{ $index }">
                        {{ $index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="dishName" label="名称" width="170" show-overflow-tooltip />
                <el-table-column prop="dishCategory" label="类别" width="70">
                </el-table-column>
            </el-table>
            <div class="demo-pagination-blocks">
                <el-pagination style="justify-content: center;" v-model:current-page="currentPage4"
                    v-model:page-size="pageSize4" @size-change="handleSizeChangese"
                    @current-change="handleCurrentChangese" :current-page="currentPage4" :page-sizes="[10, 20, 30, 40]"
                    :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="tatol">
                </el-pagination>
            </div>
            <template #footer>
                <el-button @click="handleCancel">取消</el-button>
                <el-button type="primary" @click="handleConfirm" :disabled="!selectedDoctor">确定</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { reactive, ref, toRaw, defineProps, watch, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import instance from '../network/storester.js';
import { ElMessage } from 'element-plus';

const searchForm = ref({
    keyword: ''
});
const tatol = ref(0);
const doctorfiles = ref([]);
const loading = ref(true);
const page = reactive({ pageNum: 1, pageSize: 10 });
const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
});
const emit = defineEmits(['confirm', 'update:modelValue']);
const selectedDoctor = ref(null);
// 新增变量，用于记录选中项的 id
const selectedDoctorId = ref(null);

onMounted(() => {
    siftsea();
});

const handleConfirm = () => {
    if (!selectedDoctor.value) {
        ElMessage.error('请选择关联菜品');
        return;
    }
    // 找出完整的选中项数据
    const selectedItem = doctorfiles.value.find(item => item.id === selectedDoctor.value);
    if (selectedItem) {
        emit('confirm', selectedItem);
    }
    emit('update:modelValue', false);
};

const handleCancel = () => {
    emit('update:modelValue', false);
};

const updateVisible = (value) => {
    emit('update:modelValue', value);
};

watch(() => props.modelValue, (newVal) => {
    if (!newVal) {
        selectedDoctor.value = null;
        selectedDoctorId.value = null;
    }
});

const handleSizeChangese = (val) => {
    page.pageSize = val;
    loading.value = true;
    siftsea();
};

const handleCurrentChangese = (val) => {
    page.pageNum = val;
    loading.value = true;
    siftsea();
};

const siftsea = () => {
    // 搜索前记录选中项的 id
    selectedDoctorId.value = selectedDoctor.value;
    loading.value = true;
    const keyword = searchForm.value.keyword;
    instance.get(`/api/dish/list?pageNum=${page.pageNum}&pageSize=${page.pageSize}&dishName=${keyword}`)
      .then(response => {
            doctorfiles.value = toRaw(response.data.data.dataList);
            tatol.value = response.data.data.total;
            // 搜索完成后，根据记录的 id 重新设置选中状态
            const foundItem = doctorfiles.value.find(item => item.id === selectedDoctorId.value);
            if (foundItem) {
                selectedDoctor.value = foundItem.id;
            } else {
                selectedDoctor.value = null;
            }
            loading.value = false;
        })
      .catch(error => {
            //console.log('接口请求出错:', error);
            ElMessage.error('接口请求出错，请稍后重试');
        });
};
</script>
<style>
.choose-doctors .el-dialog {
    width: 60vw;
}

.roll-dialog .el-dialog__body {
    padding: 3px 30px;
    overflow-y: auto;
    height: calc(100vh - 140px);
}

.ellipsis {
    /* white-space: nowrap; */
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
}
</style>    